import {
    faBaby,
    faBedFront,
    faBuilding,
    faCalendarAlt,
    faCalendarTime,
    faChevronDown,
    faChevronUp,
    faGarageCar,
    faHome,
    faPaw,
    faShower,
    faTimes,
    faCheck,
    faTrash,
    faUsers,
} from '@fortawesome/pro-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { debounce } from 'lodash';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from "react-redux";
import { ICON_MAP } from '../../constants/index';
import useGoogleMaps from '../../hooks/useGoogleMaps';
import { getBest, getTypesAmenities } from '../../services/properties.service';
import Spinner from '../Loader/Spinner';
import { DateTime } from 'luxon';

const ComponenteFiltros = ({
    filtros,
    setFiltros,
    limpiarPoligonosYMarcadores,
    esModal,
    expanded,
    cerrarModal,
    datosMapa
}) => {
    const {
        ubicacionBusqueda,
        rangoPrecios,
        antiguedad,
        tiposSeleccionados,
        bestAmenidadesSeleccionados,
        habitacionesSeleccionadas,
        banosSeleccionados,
        cochesSeleccionados,
        mascotasSeleccionadas,
        niñosSeleccionados,
        direccionFormateada,
        tiposPropiedadSeleccionados,
    } = filtros;

    const [valorBusqueda, setValorBusqueda] = useState(ubicacionBusqueda?.formatted_address || '');
    const [addressComponents, setAddressComponents] = useState();
    const [tempRangoPrecios, setTempRangoPrecios] = useState(rangoPrecios || [0, 100000]);
    const [tempAntiguedad, setTempAntiguedad] = useState(antiguedad || [0, 100]);
    const [tipoRenta, setTipoRenta] = useState(filtros.tipoRenta);
    const inputRef = useRef(null);
    const googleMapsLoaded = useGoogleMaps();
    const [fechaPublicacion, setFechaPublicacion] = useState(filtros.fechaPublicacion);
    const [amenidades, setAmenidades] = useState([]);
    const [bestAmenidades, setBestAmenidades] = useState([]);
    const { token } = useSelector(state => state.auth);
    const [showAmenidades, setShowAmenidades] = useState(false);
    const [showBestAmenidades, setShowBestAmenidades] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const now = DateTime.now().setZone('America/Mexico_City');
    const today = now.toISODate();
    const lastWeek = now.minus({ days: 7 }).toISODate();
    const last15Days = now.minus({ days: 15 }).toISODate();
    const lastMonth = now.minus({ days: 30 }).toISODate();

    //aqui es agregar los address_components

    useEffect(() => {
        const cargarAmenidades = async () => {
            try {
                const response = await getTypesAmenities(token);
                setAmenidades(response.data.amenities);

            } catch (error) {
                console.error('Error al cargar amenidades:', error);
            }
        };

        cargarAmenidades();
    }, [token]);

    useEffect(() => {
        const cargarBestAmenidades = async () => {
            setIsLoading(true);
            try {
                const response = await getBest(token);
                setBestAmenidades(response.data.bestAmenities);

            } catch (error) {
                console.error('Error al cargar amenidades:', error);
            }
            finally {
                setIsLoading(false);
            }
        };

        cargarBestAmenidades();
    }, [token]);

    useEffect(() => {
        if (googleMapsLoaded && window.google.maps.places && inputRef.current) {
            const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current, {
                types: ['geocode'],
                componentRestrictions: { country: 'mx' },
            });

            autocomplete.addListener('place_changed', () => {
                const place = autocomplete.getPlace();
                setValorBusqueda(place.formatted_address);
                setFiltros(prevFiltros => ({
                    ...prevFiltros,
                    ubicacionBusqueda: place,
                    direccionFormateada: place.formatted_address
                }));
                limpiarPoligonosYMarcadores();
            });
        }
    }, [googleMapsLoaded]);

    useEffect(() => {
        if (datosMapa) {
            console.log('Datos del mapa:', datosMapa);
        }
    }, []);

    useEffect(() => {
        setValorBusqueda(ubicacionBusqueda?.formatted_address || '');
    }, [ubicacionBusqueda]);

    const manejarCambioBusqueda = (e) => setValorBusqueda(e.target.value);

    const manejarEnter = (e) => {
        if (e.key === 'Enter') {
            setFiltros(prevFiltros => ({
                ...prevFiltros,
                direccionFormateada: valorBusqueda
            }));
            limpiarPoligonosYMarcadores();
        }
    };

    const borrarFiltros = () => {
        setFiltros({
            ubicacionBusqueda: null,
            rangoPrecios: [0, 100000],
            antiguedad: [0, 100],
            tiposSeleccionados: [],
            bestAmenidadesSeleccionados: [],
            habitacionesSeleccionadas: null,
            banosSeleccionados: null,
            cochesSeleccionados: null,
            mascotasSeleccionadas: null,
            niñosSeleccionados: null,
            direccionFormateada: '',
            tiposPropiedadSeleccionados: [],
            tipoRenta: [],
            fechaPublicacion: null,
        });
        limpiarPoligonosYMarcadores();
    };

    const limpiarBusqueda = () => {
        setValorBusqueda('');
        setFiltros(prevFiltros => ({
            ...prevFiltros,
            ubicacionBusqueda: null
        }));
        limpiarPoligonosYMarcadores();
    };

    const manejarCambioRangoPreciosDebounced = useCallback(debounce((valor) => {
        setFiltros(prevFiltros => ({
            ...prevFiltros,
            rangoPrecios: valor
        }));
        limpiarPoligonosYMarcadores();
    }, 500), []);

    const manejarCambioAntiguedadDebounced = useCallback(debounce((valor) => {
        setFiltros(prevFiltros => ({
            ...prevFiltros,
            antiguedad: valor
        }));
        limpiarPoligonosYMarcadores();
    }, 500), []);

    const manejarCambioRangoPrecios = (valor) => {
        setTempRangoPrecios(valor);
        manejarCambioRangoPreciosDebounced(valor);
    };

    const manejarCambioAntiguedad = (valor) => {
        setTempAntiguedad(valor);
        manejarCambioAntiguedadDebounced(valor);
    };

    const seleccionarTipo = (tipo) => {
        setFiltros(prevFiltros => ({
            ...prevFiltros,
            tiposSeleccionados: prevFiltros.tiposSeleccionados.includes(tipo)
                ? prevFiltros.tiposSeleccionados.filter(t => t !== tipo)
                : [...prevFiltros.tiposSeleccionados, tipo]
        }));
    };

    const seleccionarBestAmenidades = (tipo) => {
        setFiltros(prevFiltros => ({
            ...prevFiltros,
            bestAmenidadesSeleccionados: prevFiltros.bestAmenidadesSeleccionados.includes(tipo)
                ? prevFiltros.bestAmenidadesSeleccionados.filter(t => t !== tipo)
                : [...prevFiltros.bestAmenidadesSeleccionados, tipo]
        }));
    };

    const seleccionarTipoPropiedad = (tipo) => {
        setFiltros(prevFiltros => {
            const { tiposPropiedadSeleccionados } = prevFiltros;

            // Si el tipo seleccionado es "coliving", se deseleccionan "casa" y "departamento" y se selecciona solo "coliving"
            if (tipo === 'coliving') {
                return {
                    ...prevFiltros,
                    tiposPropiedadSeleccionados: ['coliving']
                };
            }

            const nuevoTiposPropiedadSeleccionados = tiposPropiedadSeleccionados.includes('coliving')
                ? tiposPropiedadSeleccionados.filter(t => t !== 'coliving') // Remueve "coliving" si está seleccionado
                : tiposPropiedadSeleccionados;

            return {
                ...prevFiltros,
                tiposPropiedadSeleccionados: nuevoTiposPropiedadSeleccionados.includes(tipo)
                    ? nuevoTiposPropiedadSeleccionados.filter(t => t !== tipo)
                    : [...nuevoTiposPropiedadSeleccionados, tipo]
            };
        });
    };

    const seleccionarHabitaciones = (habitaciones) => {
        setFiltros(prevFiltros => ({
            ...prevFiltros,
            habitacionesSeleccionadas: habitaciones
        }));
    };

    const seleccionarBanos = (banos) => {
        setFiltros(prevFiltros => ({
            ...prevFiltros,
            banosSeleccionados: banos
        }));
    };

    const seleccionarCoches = (coches) => {
        setFiltros(prevFiltros => ({
            ...prevFiltros,
            cochesSeleccionados: coches
        }));
    };

    const seleccionarMascotas = () => {
        setFiltros(prevFiltros => {
            let nuevoEstado;
            if (prevFiltros.mascotasSeleccionadas === null) {
                nuevoEstado = true; // Verde
            } else if (prevFiltros.mascotasSeleccionadas === true) {
                nuevoEstado = false; // Rojo
            } else if (prevFiltros.mascotasSeleccionadas === false) {
                nuevoEstado = null; // Gris
            }
            return {
                ...prevFiltros,
                mascotasSeleccionadas: nuevoEstado
            };
        });
    };

    const seleccionarNiños = () => {
        setFiltros(prevFiltros => {
            let nuevoEstado;
            if (prevFiltros.niñosSeleccionados === null) {
                nuevoEstado = true; // Verde
            } else if (prevFiltros.niñosSeleccionados === true) {
                nuevoEstado = false; // Rojo
            } else if (prevFiltros.niñosSeleccionados === false) {
                nuevoEstado = null; // Gris
            }
            return {
                ...prevFiltros,
                niñosSeleccionados: nuevoEstado
            };
        });
    };

    const seleccionarTipoRenta = (nuevoTipo) => {
        setTipoRenta(prevTipoRenta => {
            // Si el valor ya está en el array, lo eliminamos; si no, lo agregamos
            const nuevoArray = prevTipoRenta.includes(nuevoTipo)
                ? prevTipoRenta.filter(tipo => tipo !== nuevoTipo)
                : [...prevTipoRenta, nuevoTipo];

            // Actualizamos el estado con el nuevo array
            setFiltros(prevFiltros => ({
                ...prevFiltros,
                tipoRenta: nuevoArray
            }));

            return nuevoArray;
        });
    };

    const manejarCambioFechaPublicacion = (nuevaFecha) => {
        setFechaPublicacion(nuevaFecha);
        setFiltros(prevFiltros => ({
            ...prevFiltros,
            fechaPublicacion: nuevaFecha
        }));
    };

    return (
        <div className='w-full'>
            {/* Primera fila */}
            <div className={`${esModal ? 'flex flex-col gap-2' : 'flex w-full gap-3 mb-2 grow'} `}>

                {!expanded &&
                    (<div className={`flex ${esModal ? 'flex w-full' : 'flex w-6/12 md:w-4/5'} items-center gap-2 `}>
                        <div className='relative h-10 flex gap-2 items-center rounded-full px-4 bg-gray-200 w-full'>
                            <input
                                ref={inputRef}
                                type='text'
                                className='w-full h-full bg-transparent outline-none pt-0 text-gray-700 truncate'
                                autoComplete='off'
                                value={valorBusqueda}
                                onChange={manejarCambioBusqueda}
                                onKeyDown={manejarEnter}
                                placeholder='Buscar ubicación'
                            />
                            {valorBusqueda && (
                                <FontAwesomeIcon icon={faTimes} className='w-6 h-6 text-gray-700 cursor-pointer' onClick={limpiarBusqueda} />
                            )}
                        </div>
                    </div>)}
                {esModal && <label className="text-gray-700 font-semibold">Tipo de Renta</label>}

                <div className={`flex ${esModal ? 'flex' : 'flex-row items-center'} gap-2 ml-2 ${!esModal ? 'hidden lg:flex' : ''}`}>

                    <button
                        type='button'
                        className={`${esModal ? 'w-16 h-14' : 'w-28 h-16'} text-xs flex flex-col justify-center items-center rounded-lg active:scale-95 duration-100 p-2 mr-3 ${filtros.tipoRenta.includes(3) ? 'bg-blue-100 border-2 border-blue-500' : 'bg-gray-200 border-2 border-gray-300'}`}
                        onClick={() => {
                            seleccionarTipoRenta(3);
                            seleccionarTipoRenta(1);
                            seleccionarTipoRenta(2);
                        }}
                        title='Vacacional'
                    >
                        <FontAwesomeIcon icon={faCalendarTime} className={`w-5 h-5 ${filtros.tipoRenta.includes(3) ? 'text-blue-500' : 'text-gray-700'}`} />
                        <span className="text-xs text-gray-700 text-center">{`${esModal ? 'Vacacional' : 'Renta Temporal o Vacacional'}`}</span>
                    </button>

                    <button
                        type='button'
                        className={`${esModal ? 'w-16 h-14' : 'w-20 h-16'} text-xs flex flex-col justify-center items-center rounded-lg active:scale-95 duration-100 p-2 ${filtros.tipoRenta.includes(4) ? 'bg-blue-100 border-2 border-blue-500' : 'bg-gray-200 border-2 border-gray-300'}`}
                        onClick={() => seleccionarTipoRenta(4)}
                        title='Renta 12 meses o más'
                    >
                        <FontAwesomeIcon icon={faCalendarAlt} className={`w-5 h-5 ${filtros.tipoRenta.includes(4) ? 'text-blue-500' : 'text-gray-700'}`} />
                        <span className="text-xs text-gray-700 text-center">{`${esModal ? 'Anual' : 'Renta Anual'}`}</span>
                    </button>
                </div>
                <div className={`flex ${esModal ? 'flex-col' : 'flex-row items-center'} ${!esModal ? 'hidden lg:flex' : ''}`}>
                    {esModal && <label className="text-gray-700 font-semibold">Tipo de Propiedad</label>}
                    <div className={`flex ${esModal ? 'flex' : ''} gap-2 ml-2`}>
                        <button
                            type='button'
                            className={`${!esModal ? 'w-20 h-16 flex-col' : 'h-12 w-14 px-4 flex-col'} text-xs flex justify-center items-center rounded-lg active:scale-95 duration-100 ${tiposPropiedadSeleccionados.includes('casa') ? 'bg-blue-100 border-2 border-blue-500 p-1' : 'bg-gray-200 border-2 border-gray-300 p-1'}`}
                            onClick={() => seleccionarTipoPropiedad('casa')}
                            title='Casa'
                        >
                            <FontAwesomeIcon icon={faHome} className={`w-4 h-4 ${tiposPropiedadSeleccionados.includes('casa') ? 'text-blue-500' : 'text-gray-700'}`} />
                            {esModal
                                ? <span className="text-gray-700 ms-1 font-semibold">Casa</span>
                                : <span className="text-gray-700 text-xs text-center">Casa</span>
                            }
                        </button>

                        <button
                            type='button'
                            className={`${!esModal ? 'w-17 h-15 flex-col ml-3' : 'h-12 w-17 px-4 flex-col'} text-xs flex justify-center items-center rounded-lg active:scale-95 duration-100 ${tiposPropiedadSeleccionados.includes('departamento') ? 'bg-blue-100 border-2 border-blue-500 p-2' : 'bg-gray-200 border-2 border-gray-300 p-2'}`}
                            onClick={() => seleccionarTipoPropiedad('departamento')}
                            title='Departamento'
                        >
                            <FontAwesomeIcon icon={faBuilding} className={`w-4 h-4 ${tiposPropiedadSeleccionados.includes('departamento') ? 'text-blue-500' : 'text-gray-700'}`} />
                            {esModal
                                ? <span className="text-gray-700 ms-1 font-semibold">Departamento</span>
                                : <span className="text-gray-700 text-xs text-center">Departamento</span>
                            }
                        </button>
                        <button
                            type='button'
                            className={`${!esModal ? 'w-17 h-15 flex-col ml-3' : 'h-12 w-17 px-4 flex-col'} text-xs flex justify-center items-center rounded-lg active:scale-95 duration-100 ${tiposPropiedadSeleccionados.includes('coliving') ? 'bg-blue-100 border-2 border-blue-500 p-2' : 'bg-gray-200 border-2 border-gray-300 p-2'}`}
                            onClick={() => seleccionarTipoPropiedad('coliving')}
                            title='Co-living'
                        >
                            <FontAwesomeIcon icon={faUsers} className={`w-4 h-4 ${tiposPropiedadSeleccionados.includes('coliving') ? 'text-blue-500' : 'text-gray-700'}`} />
                            {esModal
                                ? <span className="text-gray-700 ms-1 font-semibold">Co-living</span>
                                : <span className="text-gray-700 text-xs text-center text-nowrap">Co-living</span>
                            }
                        </button>
                    </div>
                </div>
            </div>
            {/* Segunda fila */}
            <div className='w-full'>
                <div className={`flex w-full ${esModal ? 'flex-wrap space-y-2' : 'flex w-full gap-3'} gap-4 space-x-4 md:gap-1`}>

                    {!expanded && (
                        <>
                            {/* Botones repetidos para pantallas md o menor */}
                            <div className={`${esModal ? 'hidden' : 'w-0 md:w-full lg:hidden md:flex'} `}>
                                <div className={`flex flex-row items-center gap-2 hidden md:flex lg:hidden`}>
                                    <button
                                        type='button'
                                        className={`${esModal ? 'w-16 h-14' : 'w-28 h-16'} text-xs flex flex-col justify-center items-center rounded-lg active:scale-95 duration-100 p-2 ${filtros.tipoRenta.includes(3) ? 'bg-blue-100 border-2 border-blue-500' : 'bg-gray-200 border-2 border-gray-300'}`}
                                        onClick={() => {
                                            seleccionarTipoRenta(3);
                                            seleccionarTipoRenta(1);
                                            seleccionarTipoRenta(2);
                                        }
                                        }
                                        title='Vacacional'
                                    >
                                        <FontAwesomeIcon icon={faCalendarTime} className={`w-5 h-5 ${filtros.tipoRenta.includes(3) ? 'text-blue-500' : 'text-gray-700'}`} />
                                        <span className="text-xs text-gray-700 text-center">{`${esModal ? 'Vacacional' : 'Renta Temporal o Vacacional'}`}</span>
                                    </button>

                                    <button
                                        type='button'
                                        className={`${esModal ? 'w-16 h-14' : 'w-20 h-16'} text-xs flex flex-col justify-center items-center rounded-lg active:scale-95 duration-100 p-2 ${filtros.tipoRenta.includes(4) ? 'bg-blue-100 border-2 border-blue-500' : 'bg-gray-200 border-2 border-gray-300'}`}
                                        onClick={() => seleccionarTipoRenta(4)}
                                        title='Renta 12 meses o más'
                                    >
                                        <FontAwesomeIcon icon={faCalendarAlt} className={`w-5 h-5 ${filtros.tipoRenta.includes(4) ? 'text-blue-500' : 'text-gray-700'}`} />
                                        <span className="text-xs text-gray-700 text-center">{`${esModal ? 'Anual' : 'Renta Anual'}`}</span>
                                    </button>
                                </div>
                                <div className={`flex ${esModal ? 'flex-col' : 'flex-row items-center'} hidden md:flex lg:hidden`}>
                                    {esModal && <label className="text-gray-700 font-semibold">Tipo de Propiedad</label>}
                                    <div className={`flex ${esModal ? 'flex-col' : ''} gap-1`}>
                                        <button
                                            type='button'
                                            className={`${!esModal ? 'w-20 h-16 flex-col' : 'h-10 w-full px-4 flex-row'} text-xs flex justify-center items-center rounded-lg active:scale-95 duration-100 ml-4 ${tiposPropiedadSeleccionados.includes('casa') ? 'bg-blue-100 border-2 border-blue-500 p-1' : 'bg-gray-200 border-2 border-gray-300 p-1'}`}
                                            onClick={() => seleccionarTipoPropiedad('casa')}
                                            title='Casa'
                                        >
                                            <FontAwesomeIcon icon={faHome} className={`w-4 h-4 ${tiposPropiedadSeleccionados.includes('casa') ? 'text-blue-500' : 'text-gray-700'}`} />
                                            {esModal
                                                ? <span className="text-gray-700 ms-1 font-semibold">Casa</span>
                                                : <span className="text-gray-700 text-xs text-center">Casa</span>
                                            }
                                        </button>

                                        <button
                                            type='button'
                                            className={`${!esModal ? 'w-17 h-15 flex-col ml-3' : 'h-10 w-full px-4 flex-row'} text-xs flex justify-center items-center rounded-lg active:scale-95 duration-100 ${tiposPropiedadSeleccionados.includes('departamento') ? 'bg-blue-100 border-2 border-blue-500 p-2' : 'bg-gray-200 border-2 border-gray-300 p-2'}`}
                                            onClick={() => seleccionarTipoPropiedad('departamento')}
                                            title='Departamento'
                                        >
                                            <FontAwesomeIcon icon={faBuilding} className={`w-4 h-4 ${tiposPropiedadSeleccionados.includes('departamento') ? 'text-blue-500' : 'text-gray-700'}`} />
                                            {esModal
                                                ? <span className="text-gray-700 ms-1 font-semibold">Departamento</span>
                                                : <span className="text-gray-700 text-xs text-center">Departamento</span>
                                            }
                                        </button>
                                        <button
                                            type='button'
                                            className={`${!esModal ? 'w-17 h-15 flex-col ml-3' : 'h-12 w-17 px-4 flex-col'} text-xs flex justify-center items-center rounded-lg active:scale-95 duration-100 ${tiposPropiedadSeleccionados.includes('coliving') ? 'bg-blue-100 border-2 border-blue-500 p-2' : 'bg-gray-200 border-2 border-gray-300 p-2'}`}
                                            onClick={() => {
                                                seleccionarTipoPropiedad('coliving');
                                            }}
                                            title='Co-living'
                                        >
                                            <FontAwesomeIcon icon={faUsers} className={`w-4 h-4 ${tiposPropiedadSeleccionados.includes('coliving') ? 'text-blue-500' : 'text-gray-700'}`} />
                                            {esModal
                                                ? <span className="text-gray-700 ms-1 font-semibold">Co-living</span>
                                                : <span className="text-gray-700 text-xs text-center text-nowrap">Co-living</span>
                                            }
                                        </button>
                                    </div>
                                </div>
                            </div>
                            {/*Normal seccion de renta desde AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA*/}
                            <div className={`flex flex-col gap-4 w-2/5 ${esModal ? 'ml-5' : 'md:hidden lg:flex'} `}>
                                <div className={`flex ${esModal ? 'flex-col' : 'flex-row items-center'}`}>
                                    <div className='flex flex-col gap-1 w-full'>
                                        <p className='text-sm font-medium text-gray-700 text-center'>
                                            Renta desde <span className='text-xs font-bold text-black'>${tempRangoPrecios[0].toLocaleString()}</span> hasta{' '}
                                            <span className='text-xs font-bold text-black'>${tempRangoPrecios[1].toLocaleString()}</span>
                                        </p>
                                        <Slider
                                            range
                                            min={0}
                                            max={100000}
                                            step={1000}
                                            value={tempRangoPrecios}
                                            onChange={manejarCambioRangoPrecios}
                                            trackStyle={[{ backgroundColor: '#0368FE' }]}
                                            handleStyle={[
                                                { borderColor: '#0368FE', backgroundColor: '#0368FE' },
                                                { borderColor: '#0368FE', backgroundColor: '#0368FE' }
                                            ]}
                                            railStyle={{ backgroundColor: '#E5E7EB' }}
                                            aria-label="Rango de precios de la renta"
                                            aria-valuemin={0}
                                            aria-valuemax={100000}
                                            aria-valuetext={`Precio desde ${tempRangoPrecios[0].toLocaleString()} hasta ${tempRangoPrecios[1].toLocaleString()}`}
                                        />
                                    </div>
                                </div>


                                {esModal && (
                                    <div className={`flex flex-col gap-1`}>
                                        <p className='text-sm font-medium text-gray-700'>
                                            Antigüedad <span className='text-xs font-bold text-black'>{tempAntiguedad[0]}</span> hasta{' '}
                                            <span className='text-xs font-bold text-black'>{tempAntiguedad[1]}</span> años
                                        </p>
                                        <Slider
                                            range
                                            min={0}
                                            max={100}
                                            step={1}
                                            value={tempAntiguedad}
                                            onChange={manejarCambioAntiguedad}
                                            trackStyle={[{ backgroundColor: '#0368FE' }]}
                                            handleStyle={[
                                                { borderColor: '#0368FE', backgroundColor: '#0368FE' },
                                                { borderColor: '#0368FE', backgroundColor: '#0368FE' }
                                            ]}
                                            railStyle={{ backgroundColor: '#E5E7EB' }}
                                        />
                                    </div>
                                )}
                            </div>
                        </>
                    )}

                    {!expanded && (
                        <>
                            <div className={`${esModal ? 'flex flex-col sm:flex-row gap-6' : 'flex gap-5'}`}>
                                <div className={`flex flex-col gap-1 ${!esModal && 'hidden xl:flex items-center justify-center h-full'}`}>
                                    <div className="flex items-center gap-2">
                                        <FontAwesomeIcon icon={faBedFront} className="w-6 h-6" />
                                        {[1, 2, 3].map((habitacion, index) => (
                                            <button
                                                key={index}
                                                type="button"
                                                className={` mt-3 w-6 h-6 flex justify-center items-center rounded-full border-2 ${habitacionesSeleccionadas === habitacion ? 'border-azul bg-white' : 'border-gray-300 bg-gray-200'}`}
                                                onClick={() => {
                                                    seleccionarHabitaciones(habitacion);
                                                }}
                                            >
                                                <span className={`text-xs font-bold ${habitacionesSeleccionadas === habitacion ? 'text-azul' : 'text-gray-700'}`}>
                                                    {habitacion === 3 ? '3+' : habitacion}
                                                </span>
                                            </button>
                                        ))}
                                    </div>
                                    <span className="text-gray-700 text-sm font-semibold">Habitaciones</span>
                                </div>

                                <div className={`flex flex-col gap-1 ${!esModal && 'hidden xl:flex items-center justify-center h-full'}`}>
                                    <div className="flex items-center gap-2">
                                        <FontAwesomeIcon icon={faShower} className="w-6 h-6" />
                                        {[1, 2, 3].map((banos, index) => (
                                            <button
                                                key={index}
                                                type="button"
                                                className={`mt-3 w-6 h-6 flex justify-center items-center rounded-full border-2 ${banosSeleccionados === banos ? 'border-azul bg-white' : 'border-gray-300 bg-gray-200'}`}
                                                onClick={() => seleccionarBanos(banos)}
                                            >
                                                <span className={`text-xs font-bold ${banosSeleccionados === banos ? 'text-azul' : 'text-gray-700'}`}>
                                                    {banos === 3 ? '3+' : banos}
                                                </span>
                                            </button>
                                        ))}
                                    </div>
                                    <span className="text-gray-700 text-sm font-semibold text-center">Baños</span>
                                </div>

                                <div className={`flex flex-col gap-1 ${!esModal && 'hidden xl:flex items-center justify-center h-full'}`}>
                                    <div className="flex items-center gap-2">
                                        <FontAwesomeIcon icon={faGarageCar} className="w-6 h-6" />
                                        {[1, 2, 3].map((coche, index) => (
                                            <button
                                                key={index}
                                                type="button"
                                                className={`mt-3 w-6 h-6 flex justify-center items-center rounded-full border-2 ${cochesSeleccionados === coche ? 'border-azul bg-white' : 'border-gray-300 bg-gray-200'}`}
                                                onClick={() => seleccionarCoches(coche)}
                                            >
                                                <span className={`text-xs font-bold ${cochesSeleccionados === coche ? 'text-azul' : 'text-gray-700'}`}>
                                                    {coche === 3 ? '3+' : coche}
                                                </span>
                                            </button>
                                        ))}
                                    </div>
                                    <span className="text-gray-700 text-sm font-semibold">Estacionamientos</span>
                                </div>
                            </div>
                        </>
                    )}

                    {esModal && (
                        <div className="space-y-4 flex-col w-full">
                            <div className="border rounded-lg w-full">
                                <button
                                    type="button"
                                    className="w-full flex justify-between items-center py-3 px-4 focus:outline-none"
                                    onClick={() => setShowAmenidades(!showAmenidades)}
                                >
                                    <div>
                                        <FontAwesomeIcon icon={showAmenidades ? faChevronUp : faChevronDown} className="text-gray-500 mr-2" />
                                        <span className="text-gray-700 font-semibold">Amenidades</span>
                                    </div>
                                    <div className="flex items-center">
                                        <span className="bg-purple-800 text-white text-xs font-medium mr-2 px-2.5 py-0.5 rounded-full">
                                            {tiposSeleccionados.filter(id => amenidades.some(amenidad => amenidad.id === id)).length} Seleccionados
                                        </span>
                                    </div>
                                </button>
                                <div
                                    className={`overflow-hidden transition-max-height duration-500 ease-in-out ${showAmenidades ? 'max-h-96' : 'max-h-0'}`}
                                >
                                    <div className="p-4 bg-white">
                                        {!isLoading ? (<div className="flex flex-wrap items-center gap-2">
                                            {amenidades.map((amenidad, index) => (
                                                <div key={index} className="flex justify-center gap-1">
                                                    <button
                                                        type="button"
                                                        className={`w-10 h-10 flex justify-center items-center rounded-lg shadow-md ${tiposSeleccionados.includes(amenidad.id) ? 'bg-blue-100' : 'bg-gray-200'
                                                            } hover:bg-blue-200 transition-colors`}
                                                        onClick={() => seleccionarTipo(amenidad.id)}
                                                        title={amenidad.name}
                                                    >
                                                        <FontAwesomeIcon
                                                            icon={ICON_MAP[amenidad.icon]}
                                                            className={`w-6 h-6 ${tiposSeleccionados.includes(amenidad.id) ? 'text-azul' : 'text-gray-700'}`}
                                                        />
                                                    </button>
                                                </div>
                                            ))}
                                        </div>) : (<div className='flex justify-center items-center'><Spinner /></div>)}
                                    </div>
                                </div>
                            </div>

                            <div className="border rounded-lg w-full">
                                <button
                                    type="button"
                                    className="w-full flex justify-between items-center py-3 px-4 focus:outline-none"
                                    onClick={() => setShowBestAmenidades(!showBestAmenidades)}
                                >
                                    <div>
                                        <FontAwesomeIcon icon={showBestAmenidades ? faChevronUp : faChevronDown} className="text-gray-500 mr-2" />
                                        <span className="text-gray-700 font-semibold">Mejores Amenidades</span>
                                    </div>
                                    <div className="flex items-center">
                                        <span className="bg-purple-800 text-white text-xs font-medium mr-2 px-2.5 py-0.5 rounded-full">
                                            {bestAmenidadesSeleccionados.filter(id => bestAmenidades.some(amenidad => amenidad.id === id)).length} Seleccionados
                                        </span>
                                    </div>
                                </button>
                                <div
                                    className={`overflow-hidden transition-max-height duration-500 ease-in-out ${showBestAmenidades ? 'max-h-96' : 'max-h-0'}`}
                                >
                                    <div className="p-4 bg-white">
                                        {!isLoading ? (<div className="flex flex-wrap items-center gap-2">
                                            {bestAmenidades.map((amenidad, index) => (
                                                <div key={index} className="flex justify-center gap-1">
                                                    <button
                                                        type="button"
                                                        className={`w-10 h-10 flex justify-center items-center rounded-lg shadow-md ${bestAmenidadesSeleccionados.includes(amenidad.id) ? 'bg-blue-100' : 'bg-gray-200'
                                                            } hover:bg-blue-200 transition-colors`}
                                                        onClick={() => seleccionarBestAmenidades(amenidad.id)}
                                                        title={amenidad.name}
                                                    >
                                                        <FontAwesomeIcon
                                                            icon={ICON_MAP[amenidad.icon]}
                                                            className={`w-6 h-6 ${bestAmenidadesSeleccionados.includes(amenidad.id) ? 'text-azul' : 'text-gray-700'}`}
                                                        />
                                                    </button>
                                                </div>
                                            ))}
                                        </div>) : (<div className='flex justify-center items-center'><Spinner /></div>)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}


                    {
                        esModal && (
                            <div className="flex-col gap-2">
                                {esModal && <label className="text-gray-700 font-semibold">Otros Filtros</label>}
                                <div className="flex items-center gap-2 mt-2">
                                    <button
                                        type="button"
                                        className={`w-auto text-xs h-10 flex items-center gap-2 px-4 rounded-lg ${filtros.mascotasSeleccionadas === true ? 'bg-green-500' :
                                            filtros.mascotasSeleccionadas === false ? 'bg-red-500' : 'bg-gray-200'
                                            }`}
                                        onClick={seleccionarMascotas}
                                        title={filtros.mascotasSeleccionadas === true ? 'Sí admite mascotas' :
                                            filtros.mascotasSeleccionadas === false ? 'No admite mascotas' : 'Mascotas'}
                                    >
                                        <FontAwesomeIcon
                                            icon={faPaw}
                                            className={`w-4 h-4 ${filtros.mascotasSeleccionadas === null ? 'text-gray-700' : 'text-white'}`}
                                        />
                                        <span className={`font-semibold ${filtros.mascotasSeleccionadas === null ? 'text-gray-700' : 'text-white'}`}>
                                            {filtros.mascotasSeleccionadas === true ? 'Sí admite Mascotas' :
                                                filtros.mascotasSeleccionadas === false ? 'No admite Mascotas' : 'Mascotas'}
                                        </span>
                                    </button>

                                    <button
                                        type="button"
                                        className={`w-auto text-xs h-10 flex items-center gap-2 px-4 rounded-lg ${filtros.niñosSeleccionados === true ? 'bg-green-500' :
                                            filtros.niñosSeleccionados === false ? 'bg-red-500' : 'bg-gray-200'
                                            }`}
                                        onClick={seleccionarNiños}
                                        title={filtros.niñosSeleccionados === true ? 'Sí admite niños' :
                                            filtros.niñosSeleccionados === false ? 'No admite niños' : 'Niños'}
                                    >
                                        <FontAwesomeIcon
                                            icon={faBaby}
                                            className={`w-6 h-6 ${filtros.niñosSeleccionados === null ? 'text-gray-700' : 'text-white'}`}
                                        />
                                        <span className={`font-semibold ${filtros.niñosSeleccionados === null ? 'text-gray-700' : 'text-white'}`}>
                                            {filtros.niñosSeleccionados === true ? 'Sí admite Niños' :
                                                filtros.niñosSeleccionados === false ? 'No admite Niños' : 'Niños'}
                                        </span>
                                    </button>
                                </div>
                            </div>
                        )
                    }

                    {
                        esModal && (
                            <div className="flex-col mx-auto w-full">
                                <div className="grid grid-cols-2 gap-6 mt-4">
                                    {/* Renta Vacacional */}
                                    <div>
                                        <h4 className="text-md font-medium text-gray-800 flex items-center gap-2">
                                            <i className="fas fa-umbrella-beach"></i> Renta Vacacional
                                        </h4>
                                        <div className="flex-col gap-2 mt-2 max:sm:flex-col">
                                            <button
                                                className={`p-2 border-2 text-xs rounded-full transition-colors duration-300 ${filtros.tipoRenta.includes(1) ? 'border-blue-500 text-blue-500' : 'border-gray-300 text-gray-800'}`}
                                                onClick={() => seleccionarTipoRenta(1)}
                                            >
                                                <i className="fas fa-calendar-day mr-1"></i> Días
                                            </button>
                                            <button
                                                className={`p-2 border-2 text-xs rounded-full transition-colors duration-300 ${filtros.tipoRenta.includes(2) ? 'border-blue-500 text-blue-500' : 'border-gray-300 text-gray-800'}`}
                                                onClick={() => seleccionarTipoRenta(2)}
                                            >
                                                <i className="fas fa-calendar-week mr-1"></i> Semanas
                                            </button>
                                            <button
                                                className={`p-2 border-2 text-xs rounded-full transition-colors duration-300 ${filtros.tipoRenta.includes(3) ? 'border-blue-500 text-blue-500' : 'border-gray-300 text-gray-800'}`}
                                                onClick={() => seleccionarTipoRenta(3)}
                                            >
                                                <i className="fas fa-calendar-alt mr-1"></i> Meses
                                            </button>
                                        </div>
                                    </div>

                                    {/* Renta */}
                                    <div>
                                        <h4 className="text-md font-medium text-gray-800 flex items-center gap-2">
                                            <i className="fas fa-home"></i> Renta
                                        </h4>
                                        <div className="flex gap-2 mt-2">
                                            <button
                                                className={`p-2 border-2 text-xs rounded-full transition-colors duration-300 ${filtros.tipoRenta.includes(4) ? 'border-blue-500 text-blue-500' : 'border-gray-300 text-gray-800'}`}
                                                onClick={() => seleccionarTipoRenta(4)}
                                            >
                                                <i className="fas fa-calendar-check mr-1"></i> 12 meses o más
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                    {
                        esModal && (
                            <div className="flex gap-2 mt-2">
                                <button
                                    className={`p-2 border-2 text-xs rounded-full transition-colors duration-300 ${filtros.fechaPublicacion === today ? 'border-blue-500 text-blue-500' : 'border-gray-300 text-gray-800'}`}
                                    onClick={() => manejarCambioFechaPublicacion(today)}
                                >
                                    Hoy
                                </button>
                                <button
                                    className={`p-2 border-2 text-xs rounded-full transition-colors duration-300 ${filtros.fechaPublicacion === lastWeek ? 'border-blue-500 text-blue-500' : 'border-gray-300 text-gray-800'}`}
                                    onClick={() => manejarCambioFechaPublicacion(lastWeek)}
                                >
                                    Última semana
                                </button>
                                <button
                                    className={`p-2 border-2 text-xs rounded-full transition-colors duration-300 ${filtros.fechaPublicacion === last15Days ? 'border-blue-500 text-blue-500' : 'border-gray-300 text-gray-800'}`}
                                    onClick={() => manejarCambioFechaPublicacion(last15Days)}
                                >
                                    Últimos 15 días
                                </button>
                                <button
                                    className={`p-2 border-2 text-xs rounded-full transition-colors duration-300 ${filtros.fechaPublicacion === lastMonth ? 'border-blue-500 text-blue-500' : 'border-gray-300 text-gray-800'}`}
                                    onClick={() => manejarCambioFechaPublicacion(lastMonth)}
                                >
                                    Último mes
                                </button>
                            </div>
                        )
                    }
                </div>
                {esModal && (
                    <div className="flex w-full justify-between">
                        <button
                            type="button"
                            className="w-auto mt-4 text-xs h-10 flex items-center gap-2 px-4 rounded-lg bg-gray-200 hover:bg-red-700 hover:text-white font-semibold"
                            onClick={() => { borrarFiltros() }}
                            title="Borrar Filtros"
                        >
                            <FontAwesomeIcon
                                icon={faTrash}
                                className="w-4 h-4"
                            />
                            Borrar Filtros
                        </button>
                        <button
                            type="button"
                            className="w-auto mt-4 text-xs h-10 flex items-center gap-2 px-4 rounded-lg bg-gray-200 hover:bg-green-700 hover:text-white font-semibold"
                            onClick={cerrarModal}
                            title="Borrar Filtros"
                        >
                            <FontAwesomeIcon
                                icon={faCheck}
                                className="w-4 h-4"
                            />
                            Aplicar Filtros
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ComponenteFiltros;